import styles from './UserCircle.module.scss';
import { BrightTooltip } from '../../tooltips/BrightTooltip.tsx';
import { AppMenu } from '../../uikit/menu/AppMenu.tsx';
import { logOut, useAuth } from 'helpers/auth/auth-interceptor.ts';
import { useState, useRef, useMemo } from 'react';
import { useScopedTranslation } from 'application/localization/useScopedTranslation.ts';
import ExitIcon from 'assets/icons/exit.svg?react';
import Logger from 'js-logger';

export const UserCircle = () => {
  const auth = useAuth();
  const authData = auth && auth != 'loading' ? auth : null;
  const i18n = useScopedTranslation('Component.Header.UserCircle');

  const userMenuAnchorRef = useRef<HTMLDivElement | null>(null);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const userMenuItems = useMemo(() => {
    return [
      {
        key: 'logout',
        text: i18n.t('logout'),
        icon: <ExitIcon />,
        className: styles.logout,
        onClick: () => {
          logOut().catch((e) => Logger.error(e));
        },
      },
    ];
  }, [i18n]);

  const userNameState = useMemo(() => {
    if (!authData) return { fullName: '', abbreviation: '' };

    const firstName = authData.claims.firstName;
    const lastName = authData.claims.lastName;
    const userName = authData.claims.userName;

    if (firstName.length > 0 && lastName.length > 0)
      return {
        fullName: `${firstName} ${lastName}`,
        abbreviation: firstName[0] + lastName[0],
      };

    if (userName.length > 1)
      return {
        fullName: userName,
        abbreviation: userName.substring(0, 2).toUpperCase(),
      };

    return { fullName: '', abbreviation: '' };
  }, [authData]);

  return (
    <>
      {authData && (
        <div
          className={styles.userCircleContainer}
          ref={userMenuAnchorRef as any}
        >
          <BrightTooltip
            title={
              <div className={styles.userCircleTooltip}>
                <div>{userNameState.fullName}</div>
                <div className={styles.tooltipEmail}>
                  {authData.claims.email}
                </div>
              </div>
            }
          >
            <div
              className={styles.userCircle}
              onClick={() => setIsUserMenuOpen(true)}
            >
              {userNameState.abbreviation}
            </div>
          </BrightTooltip>
          <AppMenu
            menuItems={userMenuItems}
            open={isUserMenuOpen}
            anchorEl={userMenuAnchorRef.current}
            onClose={() => setIsUserMenuOpen(false)}
          />
        </div>
      )}
    </>
  );
};
